import React, { useContext, useEffect, useState, useCallback } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { ProductCoilSettingContext } from '../store/ProductCoilSettingContext.jsx';
import { ProductSelectContext } from '../store/ProductSelectContext.jsx';
import Octopus from '../api/payment/octopus.jsx';
import { StorefrontContext } from '../store/StorefrontContext.jsx';
import { PaymentContext, PaymentProvider } from '../store/PaymentContext.jsx';
import { forceRunMotor } from '../api/motorApi.jsx';
import { createPaidOrder, createFulfillment, createFulfillmentV2 } from '../api/adminApi.jsx';
import { createTransaction, getTransactionStatus, setTransactionStatus } from '../api/payment/zpayGateway.jsx';
import _ from 'lodash';
import * as Sentry from "@sentry/react";
import '../scss/payment.scss';
import OctopusPaymentBadge from './PaymentMethod/Octopus/OctopusPaymentBadge.jsx';
import OctopusPaymentDetails from './PaymentMethod/Octopus/OctopusPaymentDetails.jsx';

let paymentError = null;
let unpresentCardRetryCounter = 0;
const config = {
    paymentType: '',
    pollData: {},
    deductStatus: {},
    extraInfoData: {},
    transactionId: 0,
    localAmount: 0,
    transactionDateTime: '',
    startedRetryLoop: false,
    retryLoopInterval: 0,  // init timer  
    incompleteTransactionCardNumber: null,
}

var onPaymentFinish = null;

const octopusSettings = {
    max_poll_unpresent_card_retry: 9,
    error: {
        failed_to_connect_rwl: 100001,
        incomplete_transaction: 100022,
        transaction_log_full: 100023,
        authentication_fail: 100029,
        unpresent_card: 100032,
        insufficient_fund: 100048,
        others: 'others',
    },
    notifiable_errors: [100001, 100002, 100003, 100005, 100050, 100051, 100066],

    // setTransactionInterval(null);
    // setTimeoutId(null);
};

function Payment(props) {
    const [disableCancel, setDisableCancel] = useState(false)
    const [hasStartedRetryLoop, setHasStartedRetryLoop] = useState(false);
    const [retryLoopInterval, setRetryLoopInterval] = useState(0);
    const [pendingTransactionCardNumber, setPendingTransactionCardNumber] = useState(null);

    const [paymentLoading, setPaymentLoading] = useState(false);

    const [paymentTimer, setPaymentTimer] = useState(0);
    const [qrCodeValue, setQrcodeValue] = useState(null);
    const [fetchingOctopusPayResponse, setFetchingOctopusPayResponse] = useState(false);
    const [fetchingAirwallexPayResponse, setFetchingAirwallexPayResponse] = useState(false);
    const [transactionInterval, setTransactionInterval] = useState(null);
    const [timeoutId, setTimeoutId] = useState(null);

    // let transactionInterval = null;

    useEffect(() => {
        onPaymentFinish = props.finish;
    }, [props.finish]);

    const { productSelected, setProductSelected } = useContext(ProductSelectContext);
    const { state: storefrontState } = useContext(StorefrontContext);
    const { state: paymentState, dispatch: paymentDispatch } = useContext(PaymentContext);
    const { updateProductCoilSetting } = useContext(ProductCoilSettingContext);

    // useEffect(() => {
    //     // setQrCodeValue(paymentState.paymentGatewayDetails?.payment_redirect_link)
    //     if (paymentState?.paymentGatewayDetails?.payment_redirect_link) {
    //         setQrcodeValue(paymentState.paymentGatewayDetails?.payment_redirect_link)
    //     }
    // }, [paymentState])
    // reset all when close
    function cancelPayment() {
        setPaymentLoading(false)
        setFetchingAirwallexPayResponse(false)
        setFetchingOctopusPayResponse(false)
        paymentDispatch({ type: 'reset' })
        // paymentDispatch({
        //     type: 'update',
        //     payload: {
        //         paymentStatusDesc: null,
        //     }
        // })
        // setQrcodeValue(null)
        setProductSelected(null)
        // cancelFetchAirwallexResponse()
    }


    function finish(result = null) {
        console.log('finish', result);
        // create paid order in shopify
        createPaidOrder(productSelected.id, paymentState.localAmount, paymentState.paymentType, paymentState.currencyCode).then((shopifyOrderData) => {
            console.log('Shopify Order result', shopifyOrderData);
            // check motor
            const savedSettings = JSON.parse(localStorage.getItem('coilSettings'));
            // check which coils still have stock
            console.log('savedSettings', savedSettings, productSelected);
            let coilSetting = savedSettings.filter((setting) => setting.productId === productSelected.id && setting.count > 0);
            console.log('coilSetting 1', coilSetting);
            if (!coilSetting.length) {
                console.error('No coil setting found for product', productSelected.id);
                paymentDispatch({
                    type: 'update',
                    payload: {
                        paymentStatusDesc: 'Error occurred, please ask technical support for help',
                    }
                })
                return
            }

            if (coilSetting.length > 1) {
                // assign the coil having nearest expiry date
                // coilSetting = _.sortBy(coilSetting.coils, ['expiryDate']);
                coilSetting = _.sortBy(coilSetting, [
                    function (object) {
                        const date = new Date(object.expiryDate);
                        console.log('date', date);
                        return date.getTime();
                    }]);
            }
            const coilUsed = coilSetting[0]

            forceRunMotor(coilUsed.id).then((data) => {
                console.log('forceRunMotor', data);
                paymentDispatch({
                    type: 'update',
                    payload: {
                        paymentStatusDesc: 'Product drop success, please take your product',
                    }
                })
                // deduct a product count from the corresponding coil in coil setting in localStorage
                const updatedCoilSetting = savedSettings.map((setting) => {
                    if (setting.id === coilUsed.id) {
                        setting.count -= 1;
                    }
                    return setting;
                });
                updateProductCoilSetting(updatedCoilSetting);

                const shopifyFulfillmentOrderCreated = shopifyOrderData.data.orderCreate.order.fulfillmentOrders
                const shopifyFulfillmentOrderId = shopifyFulfillmentOrderCreated.edges[0].node.id
                const shopifyFulfillmentOrderLineItemId = shopifyFulfillmentOrderCreated.edges[0].node.lineItems.edges[0].node.id

                // createFulfillment(shopifyFulfillmentOrderId, shopifyFulfillmentOrderLineItemId).then((fulfillmentData) => {
                //     console.log('createFulfillment', fulfillmentData);
                //     onPaymentFinish(result)
                // })
                createFulfillmentV2(shopifyFulfillmentOrderId).then((fulfillmentData) => {
                    // delay 3 seconds to trigger paymentFinishFunction
                    console.log('createFulfillment', fulfillmentData);

                    // setTimeout(() => {
                    //     paymentFinishFunction(result)
                    // }, 3000)
                    onPaymentFinish(result)
                })
                setTimeout(() => {
                    cancelPayment()
                }, 5000)

            }).catch((error) => {
                console.error('forceRunMotor error', error)
                paymentDispatch({
                    type: 'update',
                    payload: {
                        paymentStatusDesc: 'Error occurred, please ask technical support for help',
                    }
                })
            })
        }).catch((error) => {
            console.error('Shopify Order error', error)
            paymentDispatch({
                type: 'update',
                payload: {
                    paymentStatusDesc: 'Error occurred, please ask technical support for help',
                }
            })
        })
    }

    function getLastAddValueTypeText(type) {
        switch (type.toString()) {
            case '1':
                return 'cash'
            case '2':
                return 'online'
            case '4':
                return 'aavs'
            default:
                return 'other'
        }
    }

    function getLastAddValueObject(lastAddValue) {
        let parts = lastAddValue.split(',')
        if (!['1', '2', '4'].includes(parts[1].toString())) {
            return null
        }

        return {
            date: parts[0],
            type: getLastAddValueTypeText(parts[1]),
            deviceId: parts[2],
        }
    }

    function handleIncompleteTransaction() {
        if (!hasStartedRetryLoop) {
            setHasStartedRetryLoop(true);
            setPendingTransactionCardNumber(config.pollData.cardNumber);
            setRetryLoopInterval(20); // init timer
            hasStartedRetryLoop = true
            pendingTransactionCardNumber = config.pollData.cardNumber
            retryLoopInterval = 20 // init timer
        }

        // reset timeout for incomplete transaction
        // this.$bus.$emit('reset_timeout')
        // this.$emit('resetTimeout')

        if (retryLoopInterval > 0) {
            // reset timer only if retry loop has not ended yet
            retryLoopInterval = 20
        }
        console.log('handleIncompleteTransaction', retryLoopInterval);
    }

    function cancelFetchAirwallexResponse() {
        console.log('cancelFetchAirwallexResponse executing')
        // setFetchingAirwallexPayResponse(false)
        stopFetching()
    }

    // reset all at startup
    useEffect(() => {
        paymentDispatch({
            type: 'reset',
        })
    }, [])

    useEffect(() => {
        console.log('paymentTimer', paymentTimer);
        if (paymentTimer <= 0) {
            console.log('paymentTimer <= 0');
            paymentDispatch({
                type: 'reset',
            })
            return
        }
        fetchAirwallexPayResponse();
    }, [paymentTimer])

    const startFetching = () => {
        setPaymentTimer(60000 * 5)
        const interval = setInterval(() => {
            // fetchAirwallexPayResponse();
            setPaymentTimer((prev) => prev - 1000)
        }, 1000); // Adjust the interval as needed

        setTransactionInterval(interval);
    }

    const stopFetching = () => {
        console.log('stopFetching executing')
        clearInterval(transactionInterval);
        clearTimeout(timeoutId);
    };

    useEffect(() => {
        console.log('fetchingAirwallexPayResponse', fetchingAirwallexPayResponse);
        if (fetchingAirwallexPayResponse && paymentState.paymentGatewayDetails) {
            console.log('useEffect startFetching', paymentState.paymentId);
            startFetching();
        } else {
            console.log('useEffect else cleanup', paymentState.paymentId);
            cancelFetchAirwallexResponse();
        }
        // return () => {
        //     console.log('useEffect cleanup', paymentState.paymentId);
        //     cancelFetchAirwallexResponse()
        //     // stopFetching();
        // };
    }, [fetchingAirwallexPayResponse]);

    useEffect(() => {
        if (fetchingOctopusPayResponse && productSelected) {
            console.log('useEffect fetchOctopusPayResponse', productSelected);
            fetchOctopusPayResponse();
        }
    }, [fetchingOctopusPayResponse, productSelected])

    useEffect(() => {
        if (paymentState.paymentStatus === "success") {
            finish()
        }
    }, [paymentState.paymentStatus])

    function deductOctopusCardBalance(deductInfo) {
        Octopus.deduct(deductInfo).then((deductStatus) => {
            console.log('deductStatus', deductStatus);
            // this.deductStatus = deductStatus
            config.deductStatus = deductStatus
            // console.log(`Get octopus extra information`)
            console.log('deductStatus', deductStatus);
            return Octopus.getExtraInfo()
        }).then(extraInfoData => {
            console.log(`
                Deduct octopus card balance success: ${config.localAmount}<br/>
                Transaction ID: ${config.transactionId}<br/>
                Balance Amount: ${config.deductStatus / 10}<br/>
                Card Number: ${config.pollData.cardNumber}<br/>
                Customer Info: ${_.split(config.pollData.customerInfo, '-')}
            `)

            // paymentDispatch({
            //     type: 'update',
            //     payload: {
            //         paymentStatusDesc: `
            //             Deduct octopus card balance success: ${config.localAmount}<br/>
            //             Transaction ID: ${config.transactionId}<br/>
            //             Balance Amount: ${config.deductStatus / 10}<br/>
            //             Card Number: ${config.pollData.cardNumber}<br/>
            //             Customer Info: ${_.split(config.pollData.customerInfo, '-')}
            //         `,
            //     }
            // })
            paymentDispatch({
                type: 'update',
                payload: {
                    paymentType: 'octopus',
                    paymentId: config.transactionId,
                    paymentStatusDesc: `
                        Deduct octopus card balance success: ${config.localAmount}<br/>
                        Transaction ID: ${config.transactionId}<br/>
                        Balance Amount: ${config.deductStatus / 10}<br/>
                        Card Number: ${config.pollData.cardNumber}<br/>
                        Customer Info: ${_.split(config.pollData.customerInfo, '-')}
                    `,
                    paymentGatewayDetails: extraInfoData,
                    localAmount: config.deductStatus / 10,
                    currencyCode: 'HKD'
                }
            })
            return Promise.resolve({
                // transactionId: this.transactionId,
                // transactionDateTime: this.transactionDateTime,
                // amount: this.localAmount,
                // balanceAmount: this.deductStatus / 10,
                // lastAddValue: this.getLastAddValueObject(extraInfoData),
                // cardNumber: this.pollData.cardNumber,
                // customerInfo: _.split(this.pollData.customerInfo, '-'),

                transactionId: config.transactionId,
                transactionDateTime: config.transactionDateTime,
                amount: config.localAmount,
                balanceAmount: config.deductStatus / 10,
                lastAddValue: getLastAddValueObject(extraInfoData),
                cardNumber: config.pollData.cardNumber,
                customerInfo: _.split(config.pollData.customerInfo, '-'),
            })
        }).then(result => {
            //  add product drop to payment status description
            finish(result)
        }).catch((error) => {
            console.error('deductOctopusCardBalance error', error);
            switch (error.error) {
                case octopusSettings.error.incomplete_transaction:
                    handleIncompleteTransaction()
                    deductOctopusCardBalance(deductInfo)
                    break
                case octopusSettings.error.insufficient_fund:
                    paymentDispatch({
                        type: 'update',
                        payload: {
                            paymentStatusDesc: 'Insufficient fund',
                        }
                    })
                    // fetchOctopusPayResponse()
                    setTimeout(() => {
                        cancelPayment()
                    }, 5000)
                    break
                default:
                    paymentDispatch({
                        type: 'update',
                        payload: {
                            paymentStatusDesc: 'Error occurred, please try again',
                        }
                    })
                    fetchOctopusPayResponse()
                    break
            }


            // if (error === octopusSettings.error.incomplete_transaction) {
            //     // console.log(`Incomplete transaction detected`)
            //     console.info(`Incomplete transaction detected`)

            //     handleIncompleteTransaction()
            //     deductOctopusCardBalance(deductInfo)
            // }
        })
            .finally(() => {
                // reset the productSelected and paymentStatusDesc after 5 seconds
                setTimeout(() => {
                    // setQrcodeValue(null)
                    setProductSelected(null)
                    paymentDispatch({
                        type: 'reset',
                    })
                }, 15000)
            });
    }

    function fetchOctopusPayResponse() {
        Octopus.poll().then(({ pollData }) => {
            console.log('pollData', pollData)
            config.pollData = pollData
            // console.log('pollData', pollData);
            console.info(`Deduct octopus card balance: ${productSelected.price}`)
            config.transactionId = Math.floor(Math.random() * 1000000)
            // return Octopus.deduct({
            //     amount: productSelected.price,
            //     // random transactionId
            //     // transactionId: Math.floor(Math.random() * 1000000),
            //     transactionId: config.transactionId,
            //     cardNumber: pollData.cardNumber,
            // })
            deductOctopusCardBalance({
                amount: productSelected.price,
                transactionId: config.transactionId,
                cardNumber: pollData.cardNumber,
            })
        })
            // .then(deductStatus => {
            //     // this.deductStatus = deductStatus
            //     config.deductStatus = deductStatus
            //     // console.log(`Get octopus extra information`)
            //     console.log('deductStatus', deductStatus);
            //     return Octopus.getExtraInfo()
            // }).then(extraInfoData => {
            //     console.log(`
            //         Deduct octopus card balance success: ${config.localAmount}<br/>
            //         Transaction ID: ${config.transactionId}<br/>
            //         Balance Amount: ${config.deductStatus / 10}<br/>
            //         Card Number: ${config.pollData.cardNumber}<br/>
            //         Customer Info: ${_.split(config.pollData.customerInfo, '-')}
            //     `)

            //     // paymentDispatch({
            //     //     type: 'update',
            //     //     payload: {
            //     //         paymentStatusDesc: `
            //     //             Deduct octopus card balance success: ${config.localAmount}<br/>
            //     //             Transaction ID: ${config.transactionId}<br/>
            //     //             Balance Amount: ${config.deductStatus / 10}<br/>
            //     //             Card Number: ${config.pollData.cardNumber}<br/>
            //     //             Customer Info: ${_.split(config.pollData.customerInfo, '-')}
            //     //         `,
            //     //     }
            //     // })
            //     paymentDispatch({
            //         type: 'update',
            //         payload: {
            //             paymentType: 'octopus',
            //             paymentId: config.transactionId,
            //             paymentStatusDesc: `
            //                 Deduct octopus card balance success: ${config.localAmount}<br/>
            //                 Transaction ID: ${config.transactionId}<br/>
            //                 Balance Amount: ${config.deductStatus / 10}<br/>
            //                 Card Number: ${config.pollData.cardNumber}<br/>
            //                 Customer Info: ${_.split(config.pollData.customerInfo, '-')}
            //             `,
            //             paymentGatewayDetails: extraInfoData,
            //             localAmount: config.deductStatus / 10,
            //             currencyCode: 'HKD'
            //         }
            //     })
            //     return Promise.resolve({
            //         // transactionId: this.transactionId,
            //         // transactionDateTime: this.transactionDateTime,
            //         // amount: this.localAmount,
            //         // balanceAmount: this.deductStatus / 10,
            //         // lastAddValue: this.getLastAddValueObject(extraInfoData),
            //         // cardNumber: this.pollData.cardNumber,
            //         // customerInfo: _.split(this.pollData.customerInfo, '-'),

            //         transactionId: config.transactionId,
            //         transactionDateTime: config.transactionDateTime,
            //         amount: config.localAmount,
            //         balanceAmount: config.deductStatus / 10,
            //         lastAddValue: getLastAddValueObject(extraInfoData),
            //         cardNumber: config.pollData.cardNumber,
            //         customerInfo: _.split(config.pollData.customerInfo, '-'),
            //     })
            // }).then(result => {
            //     //  add product drop to payment status description
            //     finish(result)
            // })
            .catch(error => {
                Sentry.captureException(error);
                console.log('error', error);
                // if (error && !error.error) {
                //     console.log('seems not connected to RWL, or rwl service failed');

                //     paymentDispatch({
                //         type: 'update',
                //         payload: {
                //             paymentStatusDesc: "Octopus service failed, please try again",
                //         }
                //     })
                //     // set delay 5 sec to cancel payment
                //     setTimeout(() => {
                //         console.log('Clearing interval due to payment fail:', transactionInterval);
                //         cancelPayment()
                //     }, 5000)
                //     return
                // }

                // if (error.error === this.$settings.get('octopus.error.unpresent_card')) {
                if (error.error === octopusSettings.error.unpresent_card) {
                    if (
                        hasStartedRetryLoop ||
                        // this.unpresentCardRetryCounter < this.$settings.get('octopus.max_poll_unpresent_card_retry'
                        unpresentCardRetryCounter < octopusSettings.max_poll_unpresent_card_retry
                    ) {
                        unpresentCardRetryCounter++
                        // payByOctopus(price)
                        fetchOctopusPayResponse()
                        return
                    }
                    unpresentCardRetryCounter = 0 // Reset counter
                }

                if (error.type === 'userCancel') {
                    // no need to display error message
                    // this.$log.error(error.message)
                    console.error(error.message)
                    return
                }

                // this.error = error.error
                paymentError = error.error

                console.error(error.message)

                // if (this.error === this.$settings.get('octopus.error.incomplete_transaction')) {
                if (error === octopusSettings.error.incomplete_transaction) {
                    // console.log(`Incomplete transaction detected`)
                    console.info(`Incomplete transaction detected`)
                    fetchOctopusPayResponse()
                    handleIncompleteTransaction()
                }

                // if (this.$settings.get('octopus.notifiable_errors').includes(this.error)) {
                if (octopusSettings.notifiable_errors.includes(error)) {
                    console.log('Encounter error during payment')
                    // this.$notify({
                    //     level: 'alert',
                    //     // title: `Device#${this.$settings.get('device_id')} (${getSSHPort()}) Encounter error during payment`,
                    //     title: `Device#${octopusSettings.device_id} (${getSSHPort()}) Encounter error during payment`,
                    //     message: `${error.message.toString()} with error code ${this.error}`,
                    // }, true)
                }

                if (error = octopusSettings.error.authentication_fail) {
                    console.log('Authentication failed of octopus card')
                    fetchOctopusPayResponse()
                }

                console.log('check hasStartedRetryLoop', hasStartedRetryLoop)
                // if (this.startedRetryLoop) {
                //     this.pay()
                // }
                if (hasStartedRetryLoop) {
                    // payByOctopus(price)
                    fetchOctopusPayResponse()
                }
                // .finally(() => {
                //     // reset the productSelected and paymentStatusDesc after 5 seconds
                //     setTimeout(() => {
                //         // setQrcodeValue(null)
                //         setProductSelected(null)
                //         paymentDispatch({
                //             type: 'reset',
                //         })
                //     }, 15000)
                // })
            })
    }
    function fetchAirwallexPayResponse() {
        console.log('airwallexSettings', paymentState);
        let airwallexSettings = paymentState.paymentGatewayDetails
        if (!airwallexSettings) {
            console.error('Payment gateway details are missing');
            return;
        }
        if (airwallexSettings) {
            const paymentId = airwallexSettings.id
            console.log('airwallexSettings.payment_status_link', airwallexSettings.payment_status_link);
            console.log('airwallexSettings.payment_redirect_link', airwallexSettings.payment_redirect_link);
            const signature = (new URLSearchParams((airwallexSettings.payment_status_link).split('?')[1])).get('signature');
            getTransactionStatus(paymentId, signature).then((data) => {
                console.log('getTransactionStatus', data);
                switch (data.data.code) {
                    case 1:
                        console.log(`Payment success`)
                        console.log('data.data.markRedeemed', data.data.markRedeemed);
                        const signature = (new URLSearchParams((data.data.markRedeemed).split('?')[1])).get('signature')
                        console.log('payment completed');
                        // console.log('Clearing interval:', transactionInterval);
                        // clearInterval(transactionInterval)
                        // cancelFetchAirwallexResponse()
                        setFetchingAirwallexPayResponse(false)
                        // setQrcodeValue(null)
                        paymentDispatch({
                            type: 'update',
                            payload: {
                                paymentStatusDesc: 'Payment completed',
                            }
                        })

                        // set delay 5 sec to cancel payment
                        setTimeout(() => {
                            console.log('Clearing interval:', transactionInterval);
                            finish({
                                transactionId: paymentState.paymentId,
                                transactionDateTime: paymentState.paymentGatewayDetails.created_at,
                                amount: paymentState.paymentGatewayDetails.amount_object.amount,
                                pay_response: data.data,
                                query_response: data,
                                // paymentGateway: {
                                //     name: get(this.paymentOption, 'name', 'airwallex'),
                                //     provider: 'zpay',
                                // },
                            })
                            // cancelPayment()
                        }, 5000)
                        break
                    case 2:
                        console.log(`User starts payment`)
                        // fetchAirwallexPayResponse()
                        break
                    case 3:
                        console.log(`Payment Processing`)
                        paymentDispatch({
                            type: 'update',
                            payload: {
                                paymentStatusDesc: 'Payment Processing',
                            }
                        })
                        // fetchAirwallexPayResponse()
                        break
                    case 9:
                        console.log(`Payment failed`)

                        // dispatch to set paymentStatusDesc to null
                        paymentDispatch({
                            type: 'update',
                            payload: {
                                paymentStatusDesc: "Payment failed",
                            }
                        })
                        // set delay 5 sec to cancel payment
                        setTimeout(() => {
                            console.log('Clearing interval due to payment fail:', transactionInterval);
                            cancelPayment()
                        }, 5000)

                        // this.showError(this.$i18n.t('freebie.payment_failed'))
                        break
                    // default:
                    //     setTimeout(() => {
                    //         fetchAirwallexPayResponse()
                    //     }, 1000)
                }
            }).catch((error) => {
                console.error('getTransactionStatus error', error)
                console.log('transactionInterval', transactionInterval);
                console.log('Clearing interval due to error:', transactionInterval);
                // clearInterval(transactionInterval)
                // cancelFetchAirwallexResponse()
                setFetchingAirwallexPayResponse(false)
                paymentDispatch({
                    type: 'update',
                    payload: {
                        paymentStatusDesc: 'Error occurred, please try again',
                    }
                })

            })

            console.log('transactionInterval', transactionInterval);
        }
    }

    function payByAirwallex(price) {
        setPaymentLoading(true)
        // dashboardProductId or default uuid
        const productId = productSelected?.dashboardProductId || 'd27feee3-48fa-4a55-922d-379980c0a59f';
        const locationId = storefrontState?.dashboard_location_id || '9f57be63-bb2f-45e1-b186-b32aab4e591f';
        const priceAmountObject = {
            amount: price * 100,
            currency: productSelected.priceObject.currencyCode.toLowerCase(),
            precision: 2
        }
        console.log('productId', productId, 'locationId', locationId, 'priceAmountObject', priceAmountObject);
        createTransaction(productId, locationId, priceAmountObject, 'airwallex', 'en').then(({ data }) => {
            console.log('createTransaction data', data);
            console.log('payByAirwallex', price);

            // setQrcodeValue(data.payment_redirect_link)
            setFetchingAirwallexPayResponse(true)
            paymentDispatch({
                type: 'update',
                payload: {
                    paymentType: 'airwallex',
                    paymentId: data.id,
                    // paymentStatusDesc: `
                    //     Please scan the QR code to pay ${productSelected.priceObject.currencyCode}  ${price} by Airwallex<br/>
                    //     <img className="zpay-qr-img" src="${data.payment_redirect_qr_code_image_link}" alt="Airwallex QR code" />
                    // `,
                    paymentStatusDesc: `
                        Please scan the QR code to pay ${productSelected.priceObject.currencyCode}  ${price}<br/>
                    `,
                    paymentGatewayDetails: data,
                    localAmount: price,
                    currencyCode: productSelected.priceObject.currencyCode
                }
            })
            // fetchAirwallexPayResponse()
        }).catch((error) => {
            setPaymentLoading(false)
            console.error('payByAirwallex error', error)
            // dispatch to set paymentStatusDesc to null
            // setQrcodeValue(null)
            paymentDispatch({
                type: 'update',
                payload: {
                    paymentStatusDesc: 'Error occurred, please try again',
                }
            })
        })
    }

    // function payByOctopus(price) {
    //     setPaymentLoading(true)
    //     // finish({})
    //     // return
    //     config.paymentType = 'octopus'
    //     config.localAmount = price
    //     // console.log('payByOctopus', price);
    //     Octopus.poll().then(({ pollData }) => {
    //         console.log('pollData', pollData)
    //         config.pollData = pollData
    //         // console.log('pollData', pollData);
    //         console.info(`Deduct octopus card balance: ${config.localAmount}`)
    //         config.transactionId = Math.floor(Math.random() * 1000000)
    //         return Octopus.deduct({
    //             amount: config.localAmount,
    //             // random transactionId
    //             // transactionId: Math.floor(Math.random() * 1000000),
    //             transactionId: config.transactionId,
    //             cardNumber: pollData.cardNumber,
    //         })
    //     }).then(deductStatus => {
    //         // this.deductStatus = deductStatus
    //         config.deductStatus = deductStatus
    //         // console.log(`Get octopus extra information`)
    //         console.log('deductStatus', deductStatus);
    //         return Octopus.getExtraInfo()
    //     }).then(extraInfoData => {
    //         console.log(`
    //             Deduct octopus card balance success: ${config.localAmount}<br/>
    //             Transaction ID: ${config.transactionId}<br/>
    //             Balance Amount: ${config.deductStatus / 10}<br/>
    //             Card Number: ${config.pollData.cardNumber}<br/>
    //             Customer Info: ${_.split(config.pollData.customerInfo, '-')}
    //         `)

    //         // paymentDispatch({
    //         //     type: 'update',
    //         //     payload: {
    //         //         paymentStatusDesc: `
    //         //             Deduct octopus card balance success: ${config.localAmount}<br/>
    //         //             Transaction ID: ${config.transactionId}<br/>
    //         //             Balance Amount: ${config.deductStatus / 10}<br/>
    //         //             Card Number: ${config.pollData.cardNumber}<br/>
    //         //             Customer Info: ${_.split(config.pollData.customerInfo, '-')}
    //         //         `,
    //         //     }
    //         // })
    //         paymentDispatch({
    //             type: 'update',
    //             payload: {
    //                 paymentType: 'octopus',
    //                 paymentId: config.transactionId,
    //                 paymentStatusDesc: `
    //                     Deduct octopus card balance success: ${config.localAmount}<br/>
    //                     Transaction ID: ${config.transactionId}<br/>
    //                     Balance Amount: ${config.deductStatus / 10}<br/>
    //                     Card Number: ${config.pollData.cardNumber}<br/>
    //                     Customer Info: ${_.split(config.pollData.customerInfo, '-')}
    //                 `,
    //                 paymentGatewayDetails: extraInfoData,
    //                 localAmount: config.deductStatus / 10,
    //                 currencyCode: 'HKD'
    //             }
    //         })
    //         return Promise.resolve({
    //             // transactionId: this.transactionId,
    //             // transactionDateTime: this.transactionDateTime,
    //             // amount: this.localAmount,
    //             // balanceAmount: this.deductStatus / 10,
    //             // lastAddValue: this.getLastAddValueObject(extraInfoData),
    //             // cardNumber: this.pollData.cardNumber,
    //             // customerInfo: _.split(this.pollData.customerInfo, '-'),

    //             transactionId: config.transactionId,
    //             transactionDateTime: config.transactionDateTime,
    //             amount: config.localAmount,
    //             balanceAmount: config.deductStatus / 10,
    //             lastAddValue: getLastAddValueObject(extraInfoData),
    //             cardNumber: config.pollData.cardNumber,
    //             customerInfo: _.split(config.pollData.customerInfo, '-'),
    //         })
    //     }).then(result => {
    //         //  add product drop to payment status description
    //         finish(result)
    //     }).catch(error => {
    //         console.log('error', error);
    //         if (error && !error.error) {
    //             console.log('seems not connected to RWL');
    //             return
    //         }
    //         // if (error.error === this.$settings.get('octopus.error.unpresent_card')) {
    //         if (error.error === octopusSettings.error.unpresent_card) {
    //             if (
    //                 startedRetryLoop ||
    //                 // this.unpresentCardRetryCounter < this.$settings.get('octopus.max_poll_unpresent_card_retry'
    //                 unpresentCardRetryCounter < octopusSettings.max_poll_unpresent_card_retry
    //             ) {
    //                 unpresentCardRetryCounter++
    //                 payByOctopus(price)
    //                 return
    //             }
    //             unpresentCardRetryCounter = 0 // Reset counter
    //         }

    //         if (error.type === 'userCancel') {
    //             // no need to display error message
    //             // this.$log.error(error.message)
    //             console.error(error.message)
    //             return
    //         } else {
    //             // interrupt payment cancellation for error
    //             // this.clearCancellingProcessInterval()
    //             // this.cancelling = false
    //         }

    //         // this.error = error.error
    //         error = error.error

    //         console.error(error.message)

    //         // if (this.error === this.$settings.get('octopus.error.incomplete_transaction')) {
    //         if (this.error === octopusSettings.error.incomplete_transaction) {
    //             // console.log(`Incomplete transaction detected`)
    //             console.info(`Incomplete transaction detected`)

    //             handleIncompleteTransaction()
    //         }

    //         // if (this.$settings.get('octopus.notifiable_errors').includes(this.error)) {
    //         if (octopusSettings.notifiable_errors.includes(this.error)) {
    //             console.log('Encounter error during payment')
    //             // this.$notify({
    //             //     level: 'alert',
    //             //     // title: `Device#${this.$settings.get('device_id')} (${getSSHPort()}) Encounter error during payment`,
    //             //     title: `Device#${octopusSettings.device_id} (${getSSHPort()}) Encounter error during payment`,
    //             //     message: `${error.message.toString()} with error code ${this.error}`,
    //             // }, true)
    //         }

    //         // if (this.startedRetryLoop) {
    //         //     this.pay()
    //         // }
    //         if (startedRetryLoop) {
    //             payByOctopus(price)
    //         }
    //     }).finally(() => {
    //         // reset the productSelected and paymentStatusDesc after 5 seconds
    //         setTimeout(() => {
    //             // setQrcodeValue(null)
    //             setProductSelected(null)
    //             paymentDispatch({
    //                 type: 'reset',
    //             })
    //         }, 15000)
    //     })
    // }

    const payByOctopus = (price) => {
        setPaymentLoading(true)
        const productId = productSelected?.dashboardProductId || 'd27feee3-48fa-4a55-922d-379980c0a59f';
        const locationId = storefrontState?.dashboard_location_id || '9f57be63-bb2f-45e1-b186-b32aab4e591f';

        const priceAmountObject = {
            amount: price * 100,
            currency: productSelected.priceObject.currencyCode.toLowerCase(),
            precision: 2
        }
        paymentDispatch({
            type: 'update',
            payload: {
                paymentType: 'octopus',
                // paymentId: data.id,
                paymentStatusDesc: `
                    Please present the octopus card to pay ${productSelected.priceObject.currencyCode}  ${price}<br/>
                `,
                // paymentGatewayDetails: data,
                localAmount: price,
                currencyCode: productSelected.priceObject.currencyCode
            }
        })
        setFetchingOctopusPayResponse(true)
    }
    // const paymentContent = () => {
    //     console.log('paymentType updated')
    //     switch (paymentState.paymentType?.toLowerCase()) {
    //         case 'octopus':
    //             return (
    //                 <>
    //                     Octopus Selected
    //                 </>
    //             )
    //         case 'airwallex':
    //             return (
    //                 <>
    //                     Airwallex Selected
    //                 </>
    //             )
    //         default:
    //             return (
    //                 <>
    //                     <OctopusPaymentBadge />
    //                     <button onClick={() => payByAirwallex(productSelected.price)} type="button" className="btn btn-primary btn-light payBtn-airwallex px-4 py-2 fw-bold bg-white" disabled={paymentLoading}>
    //                         {/* <img className="payBtn-img logo" src={airwallexLogo} alt="airwallex logo" /> */}
    //                         <i className="bi bi-credit-card"></i>
    //                         <span className="ms-4">Credit Card</span>
    //                     </button>
    //                 </>
    //             )
    //     }
    // }
    const paymentContent = useCallback(() => {
        console.log('paymentType updated', paymentState.paymentType)
        switch (paymentState.paymentType?.toLowerCase()) {
            case 'octopus':
                return (
                    <OctopusPaymentDetails />
                )
            case 'airwallex':
                return (
                    <>
                        Airwallex Selected
                    </>
                )
            default:
                return (
                    <div className="d-flex"
                        style={{
                            gap: '1rem'
                        }}>
                        <OctopusPaymentBadge />
                        <button onClick={() => payByAirwallex(productSelected.price)} type="button" className="btn btn-primary btn-light payBtn-airwallex px-4 py-2 fw-bold bg-white" disabled={paymentLoading}>
                            {/* <img className="payBtn-img logo" src={airwallexLogo} alt="airwallex logo" /> */}
                            <i className="bi bi-credit-card"></i>
                            <span className="ms-4">Credit Card</span>
                        </button>
                    </div>
                )
        }
    }, [paymentState.paymentType])

    // useEffect(() => {
    //     console.log('paymentState.paymentType useEffect', paymentState.paymentType);
    //     paymentContent()
    // }, [paymentState.paymentType])

    return (
        productSelected ?
            <div className="payment-modal modal" tabIndex="-1" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            {/* <h5 className="modal-title">Payment</h5>
                            {!disableCancel && <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={cancelPayment}></button>} */}
                        </div>
                        <>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-4">
                                        <img src={productSelected.imgSrc} className="item-thumbnail card-img-top" alt={productSelected.imgAltText} />
                                    </div>
                                    <div className="col-8 d-flex flex-column text-start">
                                        <h3 className="card-title">{productSelected.title}</h3>
                                        <h5 className="card-subtitle mb-2 text-body-secondary">{productSelected.currencyCode} ${productSelected.price}</h5>



                                        <div className="payment-option mt-auto">
                                            <hr />
                                            {
                                                (!paymentState.paymentType || (paymentState.paymentType === 'octopus' && paymentState.paymentStatus !== 'success')) ?
                                                    paymentContent()
                                                    :
                                                    paymentState.paymentGatewayDetails?.payment_redirect_link || paymentState?.paymentStatusDesc ?
                                                        <>
                                                            {/* <p dangerouslySetInnerHTML={{ __html: paymentState.paymentStatusDesc }}></p> */}
                                                            {/* {qrCodeValue && <QRCodeSVG value={qrCodeValue} />} */}
                                                            <p dangerouslySetInnerHTML={{ __html: paymentState.paymentStatusDesc }}></p>
                                                            {fetchingAirwallexPayResponse && paymentState.paymentGatewayDetails?.payment_redirect_link && <QRCodeSVG value={paymentState.paymentGatewayDetails.payment_redirect_link} />}
                                                        </>
                                                        :
                                                        <>
                                                            <div
                                                                className="d-flex"
                                                                style={{
                                                                    gap: '1rem'
                                                                }}
                                                            >
                                                                <button
                                                                    onClick={() => payByOctopus(productSelected.price)}
                                                                    className="btn btn-primary btn-light payBtn-airwallex px-4 py-2 fw-bold bg-white"
                                                                    style={{
                                                                        width: '35%',
                                                                    }}
                                                                    disabled={paymentLoading}

                                                                // className="d-none"
                                                                >
                                                                    {/* Pay by Octopus */}
                                                                    <img
                                                                        src="logo/octopus.png" switch
                                                                        alt="octopus logo"
                                                                        style={{
                                                                            maxWidth: '100%',
                                                                        }}
                                                                    />
                                                                </button>
                                                                {/* <button onClick={() => payByAirwallex(productSelected.price)} className="w-full">Pay by Airwallex</button> */}
                                                                <button onClick={() => payByAirwallex(productSelected.price)} type="button" className="btn btn-primary btn-light payBtn-airwallex px-4 py-2 fw-bold bg-white" disabled={paymentLoading}>
                                                                    {/* <img className="payBtn-img logo" src={airwallexLogo} alt="airwallex logo" /> */}
                                                                    <i className="bi bi-credit-card"></i>
                                                                    <span className="ms-4">Credit Card</span>
                                                                </button>
                                                            </div>
                                                        </>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {!disableCancel && <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal" onClick={cancelPayment} >Close</button>}
                            </div>
                        </>
                    </div>
                </div>
            </div>
            :
            <></>
    )
}

export default Sentry.withProfiler(Payment);